export default "__VITE_ASSET__24e986a8__"